module.exports = __webpack_public_path__ + "img/OT287896.e0ea003.webp";